// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// --- ADDED IMPORTS FOR AUTH AND FIRESTORE ---
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCiYkfH_gy4keKTDTYNfM4ugJMesVAV7fk",
  authDomain: "easy-n3.firebaseapp.com",
  databaseURL: "https://easy-n3-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "easy-n3",
  storageBucket: "easy-n3.firebasestorage.app",
  messagingSenderId: "648349859483",
  appId: "1:648349859483:web:9792d2cca13dadf315903e",
  measurementId: "G-TYEZFDZNV8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// --- INITIALIZE AND EXPORT SERVICES ---
// This fixes the "export 'auth' was not found" error
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;